<template>
  <v-dialog
    v-model="modalEditdevis"
    persistent
    max-width="600px">
    <v-card>
      <v-card-title>
        <span class="headline">Éditer un devis</span>
      </v-card-title>
      <v-card-text v-if="modalEditdevis">
        <v-container v-show="loadingstatus">
          Édition du devis en cours...
        </v-container>
        <v-container v-show="!loadingstatus">
          <v-form>
            <v-container py-0>
              <v-layout wrap>
                <v-flex
                  xs12
                  md12
                >
                  <v-text-field
                    v-model="editdevis.nom"
                    class="purple-input"
                    label="Nom"
                  />
                </v-flex>
                <v-flex
                  xs12
                  md12
                >
                  <v-text-field
                    v-model="editdevis.adresse"
                    class="purple-input"
                    label="Adresse"
                  />
                </v-flex>
                <v-flex
                  xs12
                  md12
                >
                  <v-text-field
                    v-model="editdevis.cp"
                    class="purple-input"
                    label="Code postal"
                  />
                </v-flex>
                <v-flex
                  xs12
                  md12
                >
                  <v-text-field
                    v-model="editdevis.ville"
                    class="purple-input"
                    label="Ville"
                  />
                </v-flex>
                <v-flex
                  xs12
                  md6
                >
                  <v-text-field
                    v-model="editdevis.mail"
                    class="purple-input"
                    label="Courriel"
                  />
                </v-flex>
                <v-flex
                  xs12
                  md6
                >
                  <v-text-field
                    v-model="editdevis.tel"
                    class="purple-input"
                    label="Téléphone"
                  />
                </v-flex>
                <v-flex
                  xs12
                  md12
                >
                  <span>Préférence de contact</span>
                </v-flex>
                <v-flex
                  xs12
                  md6
                >
                  <v-checkbox
                    v-model="editdevis.selectcontactmail"
                    label="Courriel"
                    required
                  />
                </v-flex>
                <v-flex
                  xs12
                  md6
                >
                  <v-checkbox
                    v-model="editdevis.selectcontacttel"
                    label="Téléphone"
                    required
                  />
                </v-flex>
                <v-flex
                  xs12
                  md4
                >
                  <v-text-field
                    v-model="editdevis.piece"
                    class="purple-input"
                    label="Nombre de pièces"
                  />
                </v-flex>
                <v-flex
                  xs12
                  md4
                >
                  <v-text-field
                    v-model="editdevis.surface"
                    class="purple-input"
                    label="Surface totale (m2)"
                  />
                </v-flex>
                <v-flex
                  xs12
                  md4
                >
                  <v-text-field
                    v-model="editdevis.angle"
                    class="purple-input"
                    label="Nombre d’angles"
                  />
                </v-flex>
                <v-flex
                  xs12
                  md6
                >
                  <v-text-field
                    v-model="editdevis.perimetre"
                    class="purple-input"
                    label="Périmètre de la pièce"
                  />
                </v-flex>
                <v-flex
                  xs12
                  md6
                >
                  <v-text-field
                    v-model="editdevis.couleur"
                    class="purple-input"
                    label="Couleur"
                  />
                </v-flex>
                <v-flex
                  xs12
                  md12>
                  <span>Message</span>
                  <v-textarea
                    v-model="editdevis.contenu"/>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="warning darken-1"
          text
          @click="closeModal('Editdevis')"
        >Annuler</v-btn
        >
        <v-btn
          color="primary darken-1"
          text
          @click="editDevis()"
        >Éditer</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { db } from '@/plugins/firebase'

export default {
  data: () => ({
    configck: {
      language: 'fr',
      removePlugins: [ 'Heading' ],
      toolbar: [ 'bold', 'italic', 'bulletedList', 'blockQuote' ]
    },
    show: false,
    invalidlog: false,
    menu: false,
    menu1: false,
    loadingstatus: false,
    rules: {
      required: value => !!value || 'Champs requis.',
      min: v => v.length >= 8 || 'Min 8 caractères',
      email: value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return pattern.test(value) || 'Courriel invalide.'
      }
    }
  }),
  computed: {
    ...mapGetters(['modalEditdevis', 'editdevis'])
  },
  methods: {
    ...mapActions(['closeModal']),
    editDevis () {
      this.loadingstatus = true
      db.collection('devis')
        .doc(this.editdevis.id)
        .update(this.editdevis)
      this.closeModal('Editdevis')
      this.loadingstatus = false
    }
  }
}
</script>
